<ct-lib-modal [label]="'jobboard.static.footer.privacy-modal.title' | transloco" #modal>
  @if (colorService.companyInfo !== null && colorService.companyInfo !== undefined){
  <h2>{{ 'jobboard.static.footer.privay-info-from' | transloco }} {{ colorService.companyInfo?.title }}</h2>
  @if (colorService.companyInfo?.privacyLink) {
  <div>
    <p
      [transloco]="'jobboard.static.footer.privay-info-from-link'"
      [translocoParams]="{companyName: colorService.companyInfo?.title}"
    ></p>
    <a [href]="colorService.companyInfo?.privacyLink" target="_blank">{{ colorService.companyInfo?.privacyLink }}</a>
  </div>
  } @if (colorService.companyInfo?.privacyConditions) {
  <div class="privacy-conditions" [innerHTML]="colorService.companyInfo?.privacyConditions"></div>
  } @if (!colorService.companyInfo?.privacyLink && !colorService.companyInfo?.privacyConditions) {
  <div>
    <p>{{ 'jobboard.static.footer.privay-info-none' | transloco }}</p>
  </div>
  } }
  <h2 class="mt-3">{{ 'jobboard.static.footer.privay-info-from' | transloco }} Catch GmbH</h2>
  <div>
    @if(colorService.companyInfo?.privacyLink) {
    <p [transloco]="'jobboard.static.footer.privay-info-from-link'" [translocoParams]="{companyName: 'Catch GmbH'}"></p>
    }
    <a href="https://catch.hr/privacy-policy" target="_blank">https://catch.hr/privacy-policy</a>
  </div>
</ct-lib-modal>
